import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { Button } from '../../components/ui/Button';
import { InputField } from '../../components/ui/InputField';
import { api, ApiError } from '../../lib/api';

export function ResetPasswordConfirmPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) return;
    setError(null);
    setSubmitting(true);
    try {
      await api.passwordResetConfirm(token, password);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Не удалось сохранить новый пароль.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout>
        <div className="mx-auto flex w-[420px] max-w-full flex-col gap-4 text-center">
          <p className="text-sm text-text-secondary">
            Ссылка недействительна. Запросите восстановление доступа заново.
          </p>
          <Link to="/reset-password" className="text-xs font-medium text-action-primary">
            Восстановить доступ
          </Link>
        </div>
      </AuthLayout>
    );
  }

  if (done) {
    return (
      <AuthLayout>
        <div className="mx-auto flex w-[420px] max-w-full flex-col gap-4 text-center">
          <div className="mx-auto flex size-12 items-center justify-center rounded-[14px] bg-status-success text-lg text-text-inverse">
            ✓
          </div>
          <h1 className="text-[22px] font-semibold text-text-primary">Пароль обновлён</h1>
          <p className="text-[13px] text-text-secondary">
            Все предыдущие сессии завершены из соображений безопасности.
          </p>
          <Button type="button" className="mt-2 w-full" onClick={() => navigate('/login')}>
            Войти с новым паролем
          </Button>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <form onSubmit={handleSubmit} className="mx-auto flex w-[420px] max-w-full flex-col gap-6">
        <div>
          <h1 className="text-[28px] font-semibold text-text-primary">Новый пароль</h1>
          <p className="mt-2 text-[13px] text-text-secondary">
            Минимум 10 символов, одна заглавная буква, цифра и специальный знак.
          </p>
        </div>

        <InputField
          label="Новый пароль"
          type="password"
          placeholder="••••••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          minLength={10}
          required
        />

        {error && <p className="text-xs font-medium text-status-warning">{error}</p>}

        <Button type="submit" className="w-full" disabled={submitting}>
          {submitting ? 'Сохраняем…' : 'Сохранить пароль'}
        </Button>
      </form>
    </AuthLayout>
  );
}
